<div class="surveys-element-dynamic-content">
    <surveys-render-survey-element
        *ngIf="transformedElement"
        [element]="transformedElement"
    ></surveys-render-survey-element>
</div>
